import FieldsFactory from "../../fields-factory"
import FieldProto from "../../proto/field-proto"
import {EntityType} from "../../../gd/const/item"
import FieldConfig from "../../proto/field-config"
import {GroupedData} from "../../../data-structures/group"
import {ViewType} from "../../../gd/const/views/view-type"

export default class FieldsCollection {

    protected _fields   : FieldProto[]
    private _entityType : EntityType

    constructor(fieldsConfig:FieldConfig[], entityType:EntityType=EntityType.DYNAMIC_MODEL) {

        this._fields        = []
        this._entityType    = entityType

        _.map(fieldsConfig, fieldConfig=>{
            fieldConfig.entityType = this._entityType // new patch by Vic
            this.addField(FieldsFactory.get(fieldConfig));
        })
    }

    all(): FieldProto[] {
        return this._fields;
    }

    get entityType(): EntityType {
        return this._entityType
    }

    get models() {return this._fields}

    hasField(fieldId:fieldId):boolean {
        const field = _.find(this._fields, field=>field.fieldId === fieldId)
        return !!field
    }

    get = (fieldId:fieldId):FieldProto => {
        // return _.find(this._fields, field=>field.fieldId === fieldId)
        const result = _.find(this._fields, field=>field.fieldId === fieldId)

        if (!result) {
            console.warn("FieldCollection (v3) ERROR #FC-1 Field not found. fieldId=", fieldId)
            // throw Error("no field with id=" + fieldId + "found")
            return new FieldProto({})
        }

        return result
    }

    /**
     * Retrieves a field from the collection by its systemFieldId.
     * @param systemFieldId - The system field ID to search for.
     * @returns The matching FieldProto instance if found, otherwise a new empty FieldProto.
     */
    getBySystemFieldId(systemFieldId: ID) {
        // Search for a field in the collection with the given systemFieldId
        const result = _.find(this._fields, (field: any) => field.systemFieldId === systemFieldId)

        // If no field is found, log a warning and return a new empty FieldProto
        if (!result) {
            console.warn("FieldsCollection getBySystemFieldId: field not found", systemFieldId)
            return new FieldProto({})
        }

        return result
    }

    fieldExists(fieldId?:fieldId|null):boolean {

        if (!fieldId) return false

        return !!_.find(this._fields, field=>field.fieldId === fieldId)
    }

    get isEmpty() {
        return this.models.length < 1
    }

    addField(field:FieldProto|false) {
        if (!field) return;

        // automatically set entity type for all fields in this collections unless one exists !
        if (!field.entityType) {
            field.entityType = this._entityType
        }

        this._fields.push(field);
    }

    public addFieldFromConfig(fieldConfig: FieldConfig) {
        const field = FieldsFactory.get(fieldConfig)
        this.addField(field)
    }

    removeById(fieldId:string) {
        _.remove(this._fields, field=>field.fieldId === fieldId);
    }

    customFields():FieldProto[] {
        return _.filter(this._fields, field=>field.isCustom)
    }

    // return array of cf ids used when add field to prevent double ids
    getCustomFieldIds() {
        return _.map(this.customFields(), field=>field.fieldId);
    }

    reset(fields: FieldProto[]) {
        this._fields = [];

        _.map(fields, field=>{
            this.addField(field)
        })
    }

    // return all fields available for conditions
    get structureConditions():GroupedData {
        return []
    }

    // return all fields available for sorting
    get structureSorting():GroupedData {
        return []
    }

    structureFilterFields(customFields?: FieldProto[]): GroupedData {
        return [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items   : _.filter(this._fields, (field:FieldProto)=>{
                    return field.isFilterAvailable
                })
            },
            {
                value   : 'custom-fields',
                label   : 'Custom',
                type    : 'custom-fields',
                items   : _.filter(customFields, (field:FieldProto)=>{
                    return field.isFilterAvailable
                })
            }
        ]
    }

    structureForGrouping(excludeFieldIds?: ID[]):GroupedData {
        return []
    }

    structureForBreakdown(excludeFieldIds?: ID[]): GroupedData {
        return []
    }

    structureAggregateFields(viewType: ViewType, customFields?: any[]): GroupedData {
        return []
    }

    // Export to json object we store somewhere
    // e.g. CRM contact -> save to company settings
    toJson() {
        return _.map(this._fields, field=>field.toJson())
    }

    // used to build glist manage fields list
    toGlist() {
        return _.map(this._fields, field=> {
            return {
                id: field.fieldId,
                name: field.label,
                type: field.type,
                field: field
            }
        })
    }

}
